// chakra imports
import { Box, ChakraProvider, Portal } from "@chakra-ui/react";
// core components
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
// file import
import theme from "theme/themeAuth.js";
import SignIn from "views/Pages/SignIn.js";

export default function Pages(props) {
  return (
    <ChakraProvider theme={theme} resetCss={false} w="100%">
      <Box w="100%">
        <Box w="100%">
          <Box w="100%">
            <Switch>
              <Route path={"/auth/signin"} component={SignIn} />
              <Redirect from="/auth" to="/auth/signin" />
            </Switch>
          </Box>
        </Box>
      </Box>
    </ChakraProvider>
  );
}
